<template>
    <section
        class="notification-container fixed md:container md:mx-auto bottom-0 left-0 right-0 duration-300 pointer-events-none z-[9999]"
        @click.stop=""
    >
        <div class="notification rounded-t-2xl text-black md:w-2/5" @click.stop>
            <div class="mx-auto w-1/2">
                <div class="toast toast-start w-1/1 mb-4">
                    <div
                        v-for="({ message, color }, index) in queue"
                        :key="index"
                        :class="`alert alert-${color} pointer-events-auto cursor-pointer mb-2`"
                        @click="dismiss(index)"
                    >
                        <div>
                            <span>{{ message }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'NotificationComponent',
    computed: {
        ...mapGetters('Notification', ['queue']),
    },
    methods: {
        ...mapActions('Notification', ['dismiss', 'notify']),
    },
};
</script>

<style scoped></style>
